import Auth from './containers/AuthContainer';

export default Auth;
